// Login links come only from the local-only `harmovi login-link` command, for
// tests and local runs; sign-in emails carry a code (ADR-015 amendment
// 2026-10-25). A link is shaped http://localhost:5173/login#t=<token>, the
// token in the fragment so it never reaches a server or a log.

const TOKEN = /^[A-Za-z0-9_-]{16,}$/

// extractToken reads the token from a whole link, just its "#t=…" part, or the
// bare token. It returns null when nothing usable is found.
export function extractToken(input: string): string | null {
  const text = input.trim()
  const marker = text.indexOf('#t=')
  const candidate = marker >= 0 ? text.slice(marker + 3) : text
  const token = decodeURIComponent(candidate.split(/[&\s]/)[0] ?? '')
  return TOKEN.test(token) ? token : null
}

// tokenFromLocation reads the token from the address bar when the app was
// opened through a login link.
export function tokenFromLocation(location: { pathname: string; hash: string }): string | null {
  if (location.pathname !== '/login' || !location.hash.startsWith('#t=')) {
    return null
  }
  return extractToken(location.hash)
}
